import router from './router' // 路由

import './beforeEach' // 全局前置守卫

export default router
